import bem from '../../../utils/bem';
import useWindowWidth from '../../../hooks/useWindowWidth';

const ResultsHeading = ({ heading, description, descriptionMobile, extra }) => {
  const baseClass = 'results-heading';
  const { breakpoint } = useWindowWidth();
  const isDesktop = breakpoint.isSmallTablet || !breakpoint.isMobile;
  return (
    <div className={bem(baseClass, [], '', extra)}>
      <p
        className={bem('heading', [], baseClass, [
          'h',
          isDesktop ? 'h4' : 'h2 text-blue',
        ])}
      >
        {heading}
      </p>
      {(description || descriptionMobile) && (
        <div
          className={bem(
            'description',
            [isDesktop ? 'desktop' : 'mobile'],
            baseClass,
          )}
          dangerouslySetInnerHTML={{
            __html: isDesktop ? description : descriptionMobile,
          }}
        />
      )}
    </div>
  );
};

export default ResultsHeading;
